export const localeAr = {
  gloabl: {
    add: "إضافة",
    edit: "تعديل",
    name: "الاسم",
    itemName: "اسم المادة",
    arabicName: "الاسم العربي",
    englishName: "الاسم الاجنبي",
    address: "العنوان",
    arabicAddress: "العنوان العربي",
    englishAddress: "العنوان الاجنبي",
    image: "الصورة ",
    anImage: "صورة",
    logo: "الشعار",
    menu: "القائمة",
    category: "الفئة",
    option: "خيار",
    url: "الرابط",
    cancel: "إلغاء",
    save: "حفظ",
    delete: "حذف",
    upload: "تحميل",
    price: "السعر",
    price_offer: "سعر الخصم",
    offers: "العروض",
    itemProperties: "خصائص المادة",
    description_ar: "الوصف باللغة العربية ",
    description: "الوصف",
    description_en: "الوصف باللغة الاجنبية ",
    hidden: "مخفي",
    unavailable: "غير متوفر",
    popular: " شائع",
    new: " جديد",
    subOptions: "خيارات فرعية ",
    options_of: "خيارات",
    sub_option: "خيار فرعي",
    option_Sets: "خيارات",
    list: "قائمة",
    pluse: "زيادة",
    mines: "نقصان",
    change_price: "تغير السعر",
    field_requird: "الحقل مطلوب",
    search_to_select: "ابحث للتحديد",
    LogOut: "تسجيل خروج",
    Login: "تسجيل دخول",
    Username: "اسم المستخدم",
    username_or_phone: "اسم المستخدم أو رقم الهاتف",
    enter_username_or_phone: "أدخل اسم المستخدم أو رقم الهاتف",
    user: "المستخدم",
    users: "المستخدمين",
    Password: "كلمة المرور",
    chooseColor: "اختيار اللون",
    colorsMenu: "الوان قائمة الطعام",
    primary: "اللون الرئيسي",
    onPrimary: "لون الخط فوق الرئيسي ",
    secondary: "اللون  الثانوي",
    onSecondary: "لون الخط فوق الثانوي",
    enable: "لون العناصر المفعلة",
    disable: "لون العناصر الغير مفعلة",
    background: "لون الخلفية ",
    onBackground: "لون الخط ",
    socialMedia: "وسائل التواصل الاجتماعي",
    branch: "فرع",
    phone: "رقم الهاتف",
    mobile: "رقم الهاتف المحمول ",
    branches: "الافرع",
    qrCode: "رمز الاستجابة السريعة",
    restaurants: "المطاعم",
    restaurant: "مطعم",
    active: "نشط",
    restaurantName: "اسم المطعم ",
    subOptionValue: "القيمة",
    yes: "نعم",
    no: "لا",
    deleteMessage:
      "سيتم حذف جميع العناصر المتعلقة بهذا العنصر ,هل تريد الحذف ؟",
    deleteMessage2: "هل تريد حذف هذا العنصر ؟",
    roulete: "الصلاحيات",
    domin: "النطاق",
    features: "الخصائص",
    select: "تحديد",
    search: "بحث",
    item: "مادة ",
    type: "نوع",
    darkMode: "الوضع الليلي",
    defaultImage: "الصورة الافتراضية",
    sumVisits: "مجموع الزيارات",
    apply: "تطبيق",
    sum: "مجموع",
    from: "من",
    to: "الي",
    veiw: "عرض",
    view: "عرض",
    visit: "زيارة",
    visits: "الزيارات",
    statistics: "احصائيات",
    total: "المجموع",
    cities: "المدن",
    countries: "الدول",
    systems: "الانظمة",
    OS: "نظام التشغيل",
    city: "مدينة",
    country: "دولة",
    scan: "مسح",
    top: "الاعلى",
    oSystem: "نظام التشغيل",
    tenant: "مستاجر",
    telegramId: "معرف التيليجرام",
    activeOrder: "الطلبات النشطة",
    createStripeAccount: "انشاء حساب سترايب",
    ConfigrationStripe: "تكوين سترايب",
    customers: "الزبائن",
    orders: "الطلبات",
    role: "صلاحية",
    addressLink: "رابط العنوان",
    wallet: "المحفظة",
    free_delivery_min_total: "توصيل مجاني",
    range_distance: "مسافة التوصيل",
    price_per_range: "سعر التوصيل",
    bonus_ratio: "نسبة البونوس",
    max_points_usage_percentage: "نسبة استخدام النقاط ",
    hidden_status_order: "اخفاء حالة الطلب",
    logs: "السجلات",
    action: "الاجراء",
    model: "النموذج",
    date: "التاريخ",
    details: "التفاصيل",
    link: "الرابط",
    title: "العنوان",
    all: "الكل",
    registered: "المسجلين",
    guests: "الزوار",
    publish: "نشر",
    target: "الهدف",
    branch_id: "رقم الفرع",
    latitude: "العرض",
    longitude: "الطول",
    coordinates_warning: "تحذير: تغيير هذه الإحداثيات سيؤثر على رسوم التوصيل",
    coordinates_warning_desc: "هذه الإحداثيات تمثل موقع المطعم كنقطة. تعديلها سيؤدي إلى إعادة حساب رسوم التوصيل لجميع الطلبات بناءً على الموقع الجديد.",
    status: "الحالة",
    order: "الطلب",
    payment_method: "طريقة الدفع",
    wallet_amount: "مبلغ المحفظة",
    table_number: "رقم الطاولة",
    time_takeaway: "وقت الاستلام",
    delivery_address: "عنوان التوصيل",
    delivery_fees: "رسوم التوصيل",
    note: "الملاحظات",
    created_at: "تاريخ الطلب",
    order_type: "نوع الطلب",
    order_payment_method: "طريقة الدفع",
    update: "تحديث",
    total_users: "إجمالي المستخدمين",
    active_users: "المستخدمين النشطين",
    today_activities: "أنشطة اليوم",
    recent_activities: "الأنشطة الأخيرة",
    new_order: "طلب جديد",
    playing_notification: "جاري تشغيل الإشعار",
    strong_alert: "تنبيه قوي",
    unread_orders: "طلبات غير مقروءة",
    click_to_view_orders: "انقر لعرض الطلبات",
    enabled: "مفعل",
    disabled: "معطل",
    copuns: "الكوبونات",
    copun: "الكوبون",
    code: "الكود",
    value: "القيمة",
    max_uses: "الحد الاقصى للاستخدام",
    is_active: "النشط",
    starts_at: "البداية",
    expires_at: "الانتهاء",
    minimum_order_amount: "الحد الادنى للطلب",
    is_first_register: "المسجل الاول",
    fixed: "ثابت",
    percentage: "نسبة",
    pick_a_date: "اختر تاريخ",
    notification: "الاشعار",
    first_register_coupon_id: "كوبون التسجيل ",
    order_details: "تفاصيل الطلب",
    quantity: "الكمية",
    sub_Total: "المجموع الفرعي",
    final_total: "المجموع النهائي",
    clear: "مسح",
    used_count: "عدد الاستخدامات",
    remaining_uses: "المتبقي",
    uses: "الاستخدامات",
    start: "البداية",
    end: "الانتهاء",
    previous: "السابق",
    next: "التالي",
    inactive: "غير مفعل",
    validity: "صلاحية",
    refund: "ارجاع",
    refund_amount: "مبلغ الإرجاع",
    confirm: "تأكيد",
    filters: "الفلاتر",
    noData: "لا يوجد بيانات",
    discount: "الخصم",
    customer: "الزبون",
    opening_time: "وقت الافتتاح",
    closing_time: "وقت الاغلاق",
    settings: "الاعدادات",
    is_free_delivery: "توصيل مجاني",
    free_delivery_note:
      "عند تفعيل هذا الخيار، يصبح حقل النوع والقيمة اختياريين. يمكنك أيضاً إضافة خصم إضافي جنباً إلى التوصيل المجاني.",
    percentage_note: "أدخل النسبة المئوية (مثل 10 = 10%)",
    fixed_note: "أدخل المبلغ الثابت بالدرهم الاماراتي",
    no_data: "لا يوجد بيانات",
    select_user_and_date: "يرجى اختيار مستخدم ونطاق تاريخ لعرض السجلات",
    table: "طاولة",
    yes_text: "نعم",
    no_text: "لا",
    processing: "جاري المعالجة...",
    coupon: "كوبون",
    select_coupon: "اختر كوبون",
    payment: "الدفع",
    delivary: "التوصيل",
    time: "الوقت",
    final: "النهائي",
    sub_total: "المجموع الفرعي",
    free_delivery: "توصيل مجاني",
    day: "يوم",
    days: "أيام",
    remaining: "متبقي",
    left: "متبقي",
    expired: "منتهي",
    today: "اليوم",
    basic_info: "المعلومات الأساسية",
    basic_info_desc: "أدخل كود الكوبون والتفاصيل الأساسية",
    discount_delivery: "الخصم والتوصيل",
    discount_delivery_desc: "قم بتكوين نوع الخصم والقيمة وخيار التوصيل المجاني",
    usage_limits: "الاستخدام والحدود",
    usage_limits_desc: "حدد حدود الاستخدام والحد الأدنى لقيمة الطلب",
    validity_period: "فترة الصلاحية",
    validity_period_desc: "حدد متى يبدأ الكوبون وينتهي",
    additional_settings: "إعدادات إضافية",
    additional_options: "خيارات إضافية",
    discount_info: "معلومات الخصم",
    optional_discount: "اختياري: يمكنك إضافة خصم مع التوصيل المجاني",
    required_discount: "مطلوب: اختر نوع الخصم والقيمة",
    no_minimum: "لا يوجد حد أدنى",
    optional_description: "اختياري: أضف وصفاً لهذا الكوبون",
    manage_coupons: "إدارة وتنظيم الكوبونات",
    filter_coupons:
      "تصفية الكوبونات حسب الكود، الحالة، النوع، أو النطاق الزمني",
    active_filters: "فلاتر نشطة",
    all_status: "جميع الحالات",
    all_types: "جميع الأنواع",
    coupons_found: "الكوبونات",
    no_coupons_found: "لا توجد كوبونات",
    no_coupons_description: "حاول تعديل الفلاتر أو إنشاء كوبون جديد",
    manage_settings: "إدارة وتكوين إعدادات التطبيق",
    delivery_settings: "إعدادات التوصيل",
    delivery_settings_desc: "تكوين خيارات التوصيل والأسعار",
    points_rewards: "النقاط والمكافآت",
    points_rewards_desc: "إدارة نقاط الولاء ونظام المكافآت",
    general_settings: "الإعدادات العامة",
    general_settings_desc: "إعدادات التطبيق الأساسية",
    hidden_status_order_desc: "إخفاء حالة الطلب من العملاء",
    manage_notifications: "إنشاء وإدارة الإشعارات الفورية للمستخدمين",
    notifications_found: "الإشعارات",
    no_notifications_found: "لا توجد إشعارات",
    no_notifications_description: "أنشئ أول إشعار للتفاعل مع المستخدمين",
    publish_to: "نشر إلى",
    content: "المحتوى",
    content_desc: "أدخل عنوان ووصف الإشعار باللغتين",
    image_desc: "قم برفع صورة للإشعار (اختياري لكن موصى به)",
    manage_customers: "عرض وإدارة الزبائن",
    customers_found: "الزبائن",
    no_customers_found: "لا يوجد زبائن",
    no_customers: "لا يوجد زبائن بعد",
    try_different_search: "جرب مصطلح بحث مختلف",
    customers_will_appear: "سيظهر الزبائن هنا بمجرد تسجيلهم",
    unknown: "غير معروف",
    email: "البريد الإلكتروني",
    deleted_account: "حساب محذوف",
    deleted_at: "تاريخ الحذف",
    delete_reason: "سبب الحذف",
    wallet_status: "المحفظة والحالة",
    wallet_status_desc: "تعيين رصيد المحفظة وحالة الحساب",
    customer_basic_info_desc: "أدخل اسم الزبون ومعلومات الاتصال",
    customer_status_desc: "تفعيل أو تعطيل حساب الزبون",
    additional_options_desc: "قم بتكوين إعدادات الكوبون الإضافية",
    description_placeholder: "وصف اختياري لهذا الكوبون",
    type_required: "مطلوب عند تعطيل التوصيل المجاني",
    unlimited: "غير محدود",
    max_uses_note: "اتركه فارغاً للاستخدام غير المحدود",
    minimum_order_note: "الحد الأدنى لقيمة الطلب لاستخدام هذا الكوبون",
    first_register: "التسجيل الأول",
    manage_social_media: "إدارة روابط وملفات وسائل التواصل الاجتماعي",
    social_media_found: "وسائل التواصل",
    no_social_media_found: "لم يتم العثور على وسائل تواصل",
    no_social_media_description:
      "أضف روابط وسائل التواصل الاجتماعي للتواصل مع عملائك",
    social_media_info: "معلومات وسائل التواصل",
    social_media_info_desc: "أضف تفاصيل منصة وسائل التواصل الاجتماعي",
    platform: "المنصة",
    select_platform: "اختر منصة وسائل التواصل الاجتماعي",
    social_media_title_desc: "أدخل اسماً لرابط وسائل التواصل هذا",
    social_media_title_placeholder: "مثال: صفحة فيسبوك",
    url_must_start_with_https: "يجب أن يبدأ الرابط بـ https://",
    manage_users: "عرض وإدارة مستخدمي النظام",
    users_found: "المستخدمون",
    no_users_found: "لم يتم العثور على مستخدمين",
    no_users_description: "أنشئ أول مستخدم للبدء",
    user_basic_info_desc: "أدخل اسم المستخدم ومعلومات الاتصال",
    role_permissions: "الدور والصلاحيات",
    role_permissions_desc: "تعيين دور المستخدم وصلاحيات الوصول",
    select_user_role: "اختر دور المستخدم وصلاحياته",
    select_user_branches: "اختر الفروع التي يمكن لهذا المستخدم الوصول إليها",
    user_status_desc: "تفعيل أو تعطيل حساب المستخدم",
    password_optional_edit: "اتركه فارغاً للاحتفاظ بكلمة المرور الحالية",
    user_name_placeholder: "أدخل اسم المستخدم",
    phone_placeholder: "أدخل رقم الهاتف",
    manage_activity_logs: "عرض وتتبع سجلات نشاط المستخدمين",
    filter_logs: "تصفية السجلات",
    filter_logs_desc: "اختر المستخدم ونطاق التاريخ لعرض سجلات النشاط",
    date_range: "نطاق التاريخ",
    logs_found: "سجلات النشاط",
    no_logs_found: "لم يتم العثور على سجلات",
    no_logs_description:
      "لم يتم العثور على سجلات نشاط للمستخدم ونطاق التاريخ المحدد",
    select_filters: "اختر الفلاتر",
    manage_branches: "عرض وإدارة فروع المطعم",
    branches_found: "الفروع",
    no_branches_found: "لم يتم العثور على فروع",
    no_branches_description: "أنشئ أول فرع للبدء",
    branch_basic_info_desc: "أدخل اسم الفرع والعنوان باللغتين",
    location_contact: "الموقع والاتصال",
    location_contact_desc: "تعيين موقع الفرع ومعلومات الاتصال",
    address_link_desc: "رابط خرائط جوجل أو رابط الموقع",
    image_status: "الصورة والحالة",
    image_status_desc: "رفع صورة الفرع وتعيين الحالة",
    branch_status_desc: "تفعيل أو تعطيل الفرع",
    qr_code: "رمز الاستجابة السريعة",
    download: "تحميل",
    manage_orders: "عرض وإدارة جميع الطلبات",
    orders_found: "الطلبات",
    no_orders_found: "لم يتم العثور على طلبات",
    no_orders_match_filters: "لا توجد طلبات تطابق الفلاتر المحددة",
    try_different_filters: "جرب تعديل الفلاتر",
    orders_will_appear: "ستظهر الطلبات هنا",
    filter_orders: "تصفية الطلبات",
    filter_orders_desc: "تصفية الطلبات حسب طريقة الدفع أو النوع أو التاريخ",
    clear_filters: "مسح الفلاتر",
    manage_menus_desc: "إدارة وتنظيم قوائم المطعم",
    no_menus_found: "لم يتم العثور على قوائم",
    menus_will_appear: "ستظهر القوائم هنا بمجرد إضافتها",
    basic_information: "المعلومات الأساسية",
    basic_information_desc: "أدخل اسم القائمة باللغتين",
    image_desc_menu: "قم برفع صورة القائمة (الحد الأقصى 4 ميجابايت)",
    manage_categories_desc: "إدارة وتنظيم فئات القائمة",
    no_categories_found: "لم يتم العثور على فئات",
    categories_will_appear: "ستظهر الفئات هنا بمجرد إضافتها",
    select_menu_desc: "اختر القائمة التي تنتمي إليها هذه الفئة",
    manage_items_desc: "إدارة وتنظيم عناصر القائمة",
    filter_items: "تصفية العناصر",
    filter_items_desc: "اختر فئة لتصفية العناصر",
    items_found: "العناصر",
    no_items_found: "لم يتم العثور على عناصر",
    no_items_in_category: "لا توجد عناصر في هذه الفئة",
    items_will_appear: "ستظهر العناصر هنا بمجرد إضافتها",
    select_category_desc: "اختر الفئة التي ينتمي إليها هذا العنصر",
    pricing: "التسعير",
    pricing_desc: "تعيين سعر العنصر وسعر العرض الاختياري",
    tags_status: "العلامات والحالة",
    tags_status_desc: "تكوين علامات العنصر وحالة التوفر",
    image_desc_item: "قم برفع صورة العنصر (الحد الأقصى 4 ميجابايت)",
    manage_options_desc: "إدارة خيارات العناصر والخيارات الفرعية",
    filter_options: "تصفية الخيارات",
    filter_options_desc: "اختر الفئة والعنصر لعرض الخيارات",
    options_found: "الخيارات",
    no_options_found: "لم يتم العثور على خيارات",
    select_item_to_view_options: "يرجى اختيار فئة وعنصر لعرض الخيارات",
    no_options_for_item: "لا توجد خيارات متاحة لهذا العنصر",
    select_item_for_option_desc:
      "اختر الفئة والعنصر الذي ينتمي إليه هذا الخيار",
    sub_option_price_desc: "تعيين السعر الإضافي لهذا الخيار الفرعي (0 للمجاني)",
    no_sub_options: "لا توجد خيارات فرعية بعد",
    free: "مجاني",
    sub_options: "الخيارات الفرعية",
    manage_sort_desc: "اسحب وأفلت العناصر لإعادة ترتيبها",
    select_category: "اختر الفئة",
    select_category_sort_desc: "اختر فئة لترتيب عناصرها",
    sort_instructions:
      "اسحب العناصر باستخدام أيقونة المقبض لإعادة ترتيبها. يتم حفظ التغييرات تلقائياً.",
    select_category_to_sort: "اختر فئة لبدء الترتيب",
    select_category_first: "يرجى اختيار فئة من الأعلى لعرض وترتيب عناصرها",
    no_items_to_sort: "لا توجد عناصر للترتيب",
    no_items_in_category_sort: "هذه الفئة لا تحتوي على عناصر بعد",
    welcome_back: "مرحباً بعودتك",
    login_description: "قم بتسجيل الدخول إلى حسابك للمتابعة",
    enter_username: "أدخل اسم المستخدم",
    login_success: "تم تسجيل الدخول بنجاح!",
    login_failed: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    login_footer: "© 2024 جميع الحقوق محفوظة",
    page_not_found: "الصفحة غير موجودة",
    page_not_found_desc: "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
    go_to_branches: "الذهاب إلى الفروع",
    go_back: "العودة",
    policies_and_terms: "السياسات والشروط",
    policies_and_terms_desc: "تحرير محتوى سياسة الخصوصية وشروط الخدمة. تنسيق بسيط فقط (عريض، قوائم، عناوين).",
    privacy_policy_ar_label: "سياسة الخصوصية (عربي)",
    privacy_policy_en_label: "سياسة الخصوصية (إنجليزي)",
    terms_of_service_ar_label: "شروط الخدمة (عربي)",
    terms_of_service_en_label: "شروط الخدمة (إنجليزي)",
    privacy_policy_placeholder_ar: "اكتب هنا سياسة الخصوصية باللغة العربية. يمكنك استخدام الخط العريض والقوائم.",
    privacy_policy_placeholder_en: "اكتب هنا سياسة الخصوصية باللغة الإنجليزية. يمكنك استخدام الخط العريض والقوائم.",
    terms_of_service_placeholder_ar: "اكتب هنا شروط الخدمة باللغة العربية.",
    terms_of_service_placeholder_en: "اكتب هنا شروط الخدمة باللغة الإنجليزية.",
    delivary_fees: "رسوم التوصيل",
    order_number: "رقم الطلب",
    discount_value: "قيمة الخصم",
    is_take_away_only: "الكوبون لطلبات الاستلام فقط",
    take_away_only_note: "عند تفعيل هذا الخيار سيتم تطبيق الكوبون على طلبات الاستلام (Take Away) فقط.",
  },
  dashbord: {
    home: "الرئيسية",
    menus: "القوائم",
    categories: "الفئات",
    items: "المواد",
    options: "الخيارات",
    sort: "ترتيب",
    branches: "الافرع",
    restaurants: "المطاعم",
    users: "المستخدمين",
    users_list: "قائمة المستخدمين",
    user_activity: "نشاط المستخدمين",
    tenants: "المستأجرين",
    orders: "الطلبات",
    customers: "الزبائن",
    settings: "الاعدادات",
    notifications: "الاشعارات",
    notification: "اشعار",
    copuns: "الكوبونات",
    coupon: "الكوبون",
    dashbordType: {
      0: "قائمة",
      1: "فئة",
      2: "مادة",
      3: "خيار",
      4: "خيار فرعي",
      5: "فرع",
      6: "مطعم",
      7: "مستخدم",
      8: "زبون",
      9: "طلب",
    },
  },
  orderType: {
    delivary: "توصيل",
    take_away: "استلام",
    dein_in: "داخلي",
  },
  paymentMethod: {
    credit: "بطاقة",
    cash: "نقدي",
  },
  actions: {
    Add: "اضافة",
    Update: "تعديل",
    Delete: "حذف",
    Accept: "قبول",
    Cancel: "الغاء",
    Send: "نشر",
    Refunded: "ارجاع",
    Refund: "ارجاع",
    Reverse: "ارجاع",
  },
  models: {
    Product: "منتج",
    Category: "فئة",
    Option: "خيار",
    SubOption: "خيار فرعي",
    Branch: "فرع",
    Section: "قسم",
    User: "مستخدم",
    Customer: "زبون",
    Setting: "اعدادات",
    SocialMedia: "تواصل اجتماعي",
    Notification: "اشعار",
    Order: "طلب",
    Coupon: "كوبون",
  },
  userTypes: {
    admin: "مدير ",
    data_manager: "مدير البيانات",
    call_center: "مركز الاتصال",
  },
  orderStatus: {
    pending: "قيد الانتظار",
    processing: "قيد التجهيز",
    delivarying: "قيد التوصيل",
    completed: "مكتمل",
    canseled: "ملغى",
  },
  errorMessage: {
    fieldRequired: "مطلوب ",
    fillAll: "الرجاء ملئ جميع الحقول المطلوبة",
    fieldCharsLength: ` يجب ان يكون حرفين  على الاقل`,
    startwith: " يجب ان يبدأ ب",
    worngLogin:
      "اسم المستخدم أو كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.",
    login_failed:
      "فشل تسجيل الدخول. يرجى التحقق من بياناتك والمحاولة مرة أخرى.",
    serverError: "حدث خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً.",
    unauthorizedError: "ليس لديك صلاحية لتنفيذ هذا الإجراء.",
    genericError: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    103: "هذا العنصر موجود بالفعل",
    noData: "لا يوجد بيانات",
  },
  messages: {
    imageNotSelected:
      "في حال عدم تحديد صورة، سيتم استخدام صورة آخر منتج تمت إضافته إلى القائمة",
    store: " تم الحفظ بنجاح!",
    update: " تم التحديث بنجاح!",
    delete: " تم الحذف بنجاح!",
    add: " تم الإضافة بنجاح!",
    publish: " تم نشر الإشعار بنجاح!",
    not_found: " البيانات غير موجودة",
  },
};
